import { render, staticRenderFns } from "./HomeGoodBgList.vue?vue&type=template&id=07cb54b2&scoped=true&"
import script from "./HomeGoodBgList.vue?vue&type=script&lang=js&"
export * from "./HomeGoodBgList.vue?vue&type=script&lang=js&"
import style0 from "./HomeGoodBgList.vue?vue&type=style&index=0&id=07cb54b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cb54b2",
  null
  
)

export default component.exports